export const categoriesFilters = [
  {
    label: 'Festas & Shows',
    icon: 'https://images.sympla.com.br/67e555878c37e.svg',
    link: '/eventos/show-musica-festa',
  },
  {
    label: 'Stand-up Comedy',
    icon: 'https://images.sympla.com.br/67e555e377ae6.svg',
    link: '/eventos/stand-up-comedy',
  },
  {
    label: 'Esportes',
    icon: 'https://images.sympla.com.br/67e55611529e2.svg',
    link: '/eventos/esportivo',
  },
];
